import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class AdjustInventoryService extends ApiService {
  namespace = "adjust-inventory";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "PO";
  DOMAIN = DOMAIN.ADJUST_INVENTORY;
  data = [];
  favicon = "Bullets";
  name = "Prchase Order";
  singular = this.terminology.purchaseOrder.singular;
  plural = this.terminology.purchaseOrder.plural;
  vowel = this.terminology.purchaseOrder.vowel;
  layout = 2;
  Width = 1500;
  moreItems = [
    {
      key: "create",
      label: "Load template",
      // icon: PrimeIcons.FOLDER,
      icon: "Folder",
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      // icon: PrimeIcons.FILE,
      icon: "Preview",
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      // icon: PrimeIcons.PRINT,
      icon: "Printer",
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      // icon: PrimeIcons.ENVELOPE,
      icon: "Mail",
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      // icon: PrimeIcons.LIST,
      icon: "Layout",
      type: "5",
    },
  ];
  constructor() {
    super("adjust-inventory");
  }
}
